var ResponseModel = /** @class */ (function () {
    function ResponseModel() {
    }
    ResponseModel.isOk = function (res) {
        return res && res.status === "OK";
    };
    ResponseModel.isError = function (res) {
        return res && res.status === "ERROR";
    };
    return ResponseModel;
}());
export { ResponseModel };
